import React, { Suspense } from "react";
import SnackBar from './components/hooks/snackBar/snackbar';
import Loader from "./components/loader/loader";
import Router from "./components/routes/Routers";
import ThemeSetUp from "./components/theme/theme";
import { HelmetProvider } from "react-helmet-async";
import NoNetwork from "./components/noNetwork/noNetwork";
import { useMediaQuery } from "@mui/material";
import NotVisibleScreen from "./layout/app/dashboard/notVisibleScreen";

export default function App() {
  const isScreenLarge = useMediaQuery('(min-width:900px)');
return (
  <NoNetwork>
    <HelmetProvider>
      <ThemeSetUp >
          <SnackBar />
            <Suspense fallback={<Loader />}>
            {isScreenLarge ? <Router /> : <NotVisibleScreen />}
          </Suspense>
        </ThemeSetUp>
    </HelmetProvider>
  </NoNetwork>
  );
}